import { OnInit } from '@angular/core';
import { Eventlog } from './eventlog';
import { TitleRequest } from './titleRequest';

export class Title{
    content_id: string;
    title: string;
    catalog_state: number;
    manual_addition: number;
    pdr_gen_start: Date;
    data_start_from: Date;
    locale: string;
    production_state: number;
    images_added: number;
    coremeta_added: number;
    pa_genes_added: number;
    dsreq_met: number ;
    added_date: Date;
    last_checked_date: Date;
    content_requests: TitleRequest[];
    content_title_eventlog: Eventlog[];


    constructor(){
    }


}


// WEBPACK FOOTER //
// ./src/app/tms/model/title.ts